export const formSubmitPreventer = () => {
  if (!document.body.getAttribute('data-template-name')) {
    const targetNode = document.body
    const observer = new MutationObserver(() => {
      const form = document.querySelector('.wishlist-form');
      if (form) {
        form.addEventListener('submit', e => e.preventDefault())
        observer.disconnect()
      }
    });
    observer.observe(targetNode, {childList:true})
  }
}